import React, { useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "../../assets/images/logo_new.svg";
import ConfirmModal from "../confirmModal/confirmModel";
import ProfileHeaderDropdown from "./ProfileHeaderDropdown";
import { clearAuthSession } from "../../helpers/authSession";
import { closeMobileSidebarDrawer } from "../../util/sidebarToggle";
import { useDispatch } from "react-redux";
import { deleteOrganiserItSelfAction } from "../../store/features/organiser/organiserSlice";
import { showToast } from "../../store/features/toast/toastSlice";

function HeaderOrganiser(props) {
  const { toggleMenuCallback } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [deleteAccountModal, setdeleteAccountModal] = useState(false);
  // Reserved if delete-account flow is re-enabled
  // eslint-disable-next-line no-unused-vars -- used when delete UI is uncommented
  const deleteAccountModalOpen = () => {
    setdeleteAccountModal(true);
  };
  const closeDeleteAccountModel = () => {
    setdeleteAccountModal(false);
  };

  const deleteAccountFunction = (e, item) => {
    dispatch(deleteOrganiserItSelfAction()).then(async (resultAction) => {
      if (deleteOrganiserItSelfAction.fulfilled.match(resultAction)) {
        setdeleteAccountModal(false);
        console.log("delete account------", resultAction);

        await clearAuthSession(dispatch);
        navigate("/", { replace: true });
      } else if (deleteOrganiserItSelfAction.rejected.match(resultAction)) {
        setdeleteAccountModal(false);
        dispatch(
          showToast({
            show: false,
            message: resultAction?.error?.message,
            type: "error",
          })
        );
      }
    });
  };
  return (
    <>
      <header
        id="page-topbar"
        className={`headerOrganiserStyle${
          toggleMenuCallback ? " headerWithSidebarLayout" : ""
        }`}
      >
        <div className="navbar-header">
          <div className="headerContainer">
            <div className="d-flex align-items-center flex-grow-1">
              {toggleMenuCallback && (
                <button
                  type="button"
                  onClick={toggleMenuCallback}
                  className="btn btn-sm font-size-16 header-item BurgerMenu me-2"
                  id="vertical-menu-btn"
                  aria-label="Toggle menu"
                >
                  <i className="fa fa-fw fa-bars" />
                </button>
              )}
              {!toggleMenuCallback && (
                <div className="logoStyle">
                  <img src={Logo} alt="logo" />
                </div>
              )}
            </div>
            <div className="rightContainStyle">
              <ProfileHeaderDropdown onBeforeLogoutOpen={closeMobileSidebarDrawer} />
            </div>
          </div>
        </div>
      </header>
      <ConfirmModal
        className={"deleteAccountModalStyle"}
        modalTitle={t("DELETE_ACCOUNT")}
        modalDescription={t("ARE_YOU_SURE_YOU_WANT_TO_DELETE_YOUR_ACCOUNT")}
        noteText={t(
          "PLEASE_NOTE_ON_DELETING_YOUR_ACCOUNT_YOU_WILL_LOSE_ALL_DATA_FOR_THE_ASSIGNED_EVENTS"
        )}
        isUnderline={false}
        note={true}
        showModal={deleteAccountModal}
        leftBtnTitle={t("YES_CONFIRM")}
        isModelIcon={true}
        iconColor={"bx bx-trash"}
        iconCricle={"iconCricleDelete"}
        leftBtnClass={"ok_Btn"}
        isFirstButton={true}
        isSecondButton={true}
        rightBtnClass="borderButton"
        rightBtnTitle={t("NO_CANCEL")}
        onProcced={(e, item) => deleteAccountFunction(e, item)}
        rightButtonClick={closeDeleteAccountModel}
      />
    </>
  );
}

HeaderOrganiser.propTypes = {
  toggleMenuCallback: PropTypes.func,
};

export default HeaderOrganiser;
